import { colors } from '@globals/themes/defaultTheme'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import CloseIcon from '@mui/icons-material/Close'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { t } from '@transifex/native'
import { ReactNode } from 'react'
import useRecognitionModal from './useRecognitionModal'

type BackModalHeaderProps = {
  title: ReactNode
  onBackClicked: () => void
}
const BackModalHeader: React.FC<BackModalHeaderProps> = ({ title, onBackClicked }) => {
  const { closeDialog } = useRecognitionModal()
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      height={60}
      alignItems="center"
      borderBottom={`1px solid ${colors.grayExtraLight}`}
      p={2}>
      <Stack direction="row" alignItems="center" useFlexGap gap={1}>
        <Button
          id="expandCheckInCategoryRow"
          aria-label={t('Back button')}
          size="small"
          onClick={() => onBackClicked()}>
          <ArrowBackIcon />
        </Button>
        <Typography variant="subtitle1">{title}</Typography>
      </Stack>
      <Button
        id="closeModalButton"
        aria-label={t('Close button')}
        size="small"
        onClick={() => closeDialog()}>
        <CloseIcon />
      </Button>
    </Stack>
  )
}

export default BackModalHeader
